import { useParams } from 'react-router-dom';

export const useDateParam = (): string => {
    const params = useParams();
    if (params.date) {
        return params.date;
    }
    return 'now';
};
